import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerColumns, paymentMethods } from '../../data/navigation';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('success');
    setEmail('');
  };
  return <footer className="bg-ink text-white" data-id="element-189" data-mp="3n3k9g59palpv">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-id="element-190" data-mp="3n4lvt5w62umw">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-191" data-mp="3j28tkrgmpeuv">
          <div className="lg:col-span-4" data-id="element-192" data-mp="3j3toii6uuzt9">
            <Logo inverted data-id="element-193" data-mp="3e2mesdl5jqjy" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60" data-id="element-194" data-mp="3e1ujl3vgvuu7">
              Batteries, power stations and solar for homes and businesses in the Netherlands and Belgium.
            </p>
            <form onSubmit={handleSubmit} className="mt-6 max-w-sm" noValidate data-id="element-195" data-mp="2kcbcpj7u8apf">
              <label htmlFor="newsletter" className="text-sm font-semibold" data-id="element-196" data-mp="2p434ty6n6oho">
                Deals &amp; new arrivals in your inbox
              </label>
              <div className="mt-2 flex gap-2" data-id="element-197" data-mp="2babx8vch1eol">
                <input id="newsletter" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                setStatus('idle');
              }} placeholder="you@email.com" aria-invalid={status === 'error'} aria-describedby="newsletter-status" className="h-11 min-w-0 flex-1 rounded-lg border border-white/15 bg-ink-soft px-3.5 text-sm text-white placeholder:text-white/40 focus:border-volt focus:outline-none" data-id="element-198" data-mp="2gaq78ixmuyp9" />
                <button type="submit" className="h-11 shrink-0 rounded-lg bg-volt px-4 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-199" data-mp="1nnn8bpp1olyh">
                  Subscribe
                </button>
              </div>
              <p id="newsletter-status" className="mt-2 min-h-[1.25rem] text-xs" aria-live="polite" data-id="element-200" data-mp="ur4k0892uuvi">
                {status === 'error' && <span className="text-red-300" data-id="element-201" data-mp="pr8gsb87f7h0">Please enter a valid email address.</span>}
                {status === 'success' && <span className="inline-flex items-center gap-1 text-volt" data-id="element-202" data-mp="fveui04onzm1">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-203" data-mp="fxhunczjv94h" /> You’re subscribed.
                  </span>}
              </p>
            </form>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8 lg:pl-10" data-id="element-204" data-mp="6wjqmup431lw">
            {footerColumns.map(col => <div key={col.title} data-id="element-205" data-mp="218rgvuqhmubc">
                <h3 className="text-sm font-semibold" data-id="element-206" data-mp="219t1apte8t5q">{col.title}</h3>
                <ul className="mt-4 space-y-2.5" data-id="element-207" data-mp="28siq0ukv7pd2">
                  {col.links.map(l => <li key={l.label} data-id="element-208" data-mp="2dqk9vhq47spl">
                      <Link to={l.href} className="text-sm text-white/60 transition-colors duration-150 hover:text-white" data-id="element-209" data-mp="2dpj0risntgai">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-6 md:flex-row md:items-center md:justify-between" data-id="element-210" data-mp="1puzk3ztpemuv">
          <ul className="flex flex-wrap gap-2" aria-label="Payment methods" data-id="element-211" data-mp="1zrccmudiiuo1">
            {paymentMethods.map(m => <li key={m} className="rounded-md bg-white px-2.5 py-1 text-xs font-bold text-ink" data-id="element-212" data-mp="23t67un4xv6gt">
                {m}
              </li>)}
          </ul>
          <p className="text-xs text-white/50" data-id="element-213" data-mp="3b8u2cpy9dtrk">© 2026 Ampra Energy B.V. · KvK 81234567 · Prices incl. VAT</p>
        </div>
      </div>
    </footer>;
}